import React, { useState } from "react";
import HeaderBar from "../../components/header/headerBar";
import "../../assets/styles/admin/jobcost.scss";
import MainButton from "../../components/button/mainButton";
import Icon from "@mdi/react";
import { mdiPrinter } from "@mdi/js";
import JobCostImage from "../../assets/images/jobcost_from.png";

const PrintForm = () => {
  return (
    <div>
      <HeaderBar title="JOB COST MAIN" btnBack={true} />
      <div style={{ marginTop: "20px" }}>
        <div style={{ padding: "0px 80px" }}>
          <div className="justify-center">
            <div className="Wapper">
              <div className="TextWapper">
                <h6>ใบเสร็จรับเงิน</h6>
              </div>
              <div>
                <MainButton title="Print" to={`#`}>
                  <Icon path={mdiPrinter} size="20" color="#FFFFFF" />
                </MainButton>
              </div>
            </div>
          </div>
          <div className="justify-center mt-20">
            <img src={JobCostImage} />
          </div>
          <div className="justify-center mt-20">
            <MainButton className="mg-10" title="ย้อนกลับ" to={"/jobcost"} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default PrintForm;
